/**
 * ★★ Feriado sem meta (02/11/2026) — O QUE CADA BOTÃO DA AGENDA FAZ COM UMA DATA. Puro.
 *
 * ★★★ Desde esta peça, "bloquear", "remover" e "marcar como feriado" GRAVAM NA HORA, só aquela
 * data (decisão P1 do dono). ⚠ Antes elas mudavam só a tela, e quem saía sem "Salvar grade"
 * perdia o bloqueio — foi assim que o 02/11 não chegou ao banco.
 *
 * ★ Cada função recebe a exceção ATUAL daquela data — a do SERVIDOR, lida dentro da transação
 * (`alterarExcecaoDaAgenda`) — e devolve a nova, ou `null` para apagar. ⚠ Nunca a cópia da
 * tela: uma segunda aba aberta com o retrato antigo não pode desfazer o que a primeira gravou.
 */
import { ehDiaInteiro } from '@/produtividade/feriados';

/** O dia inteiro fechado. `semMeta` só entra quando é `true` (D1: o padrão é "só fecha a agenda"). */
export const bloqueioDoDiaInteiro = ({ motivo = '', semMeta = false } = {}) => ({
  horarios: [],
  motivo: String(motivo ?? '').trim(),
  ...(semMeta === true ? { semMeta: true } : {}),
});

/**
 * ★ A faixa de horas soma às faixas que JÁ estão na data (duas reuniões são dois bloqueios).
 *
 * ⚠ `horarios` NÃO é gravado: a ausência da chave é o que faz o dia herdar a grade da semana e
 * perder só a faixa. Gravar `horarios: []` fecharia o dia inteiro. ★ Faixa nunca é feriado
 * (D2): um dia inteiro que vira faixa perde o `semMeta` junto.
 */
export function comFaixa(atual, { de, ate, motivo = '' }) {
  // ★ a mesma regra que a tela usava antes desta peça (`SecaoAgenda.jsx`, até 01/11)
  const anteriores = !Array.isArray(atual) && Array.isArray(atual?.bloqueios) ? atual.bloqueios : [];
  const m = String(motivo ?? '').trim();
  return { bloqueios: [...anteriores, { de, ate, motivo: m }], motivo: m };
}

/**
 * ★ "marcar como feriado" / "não é feriado": troca SÓ o `semMeta` de um dia inteiro.
 *
 * ⚠ Lança se a data não for (mais) um dia inteiro — por exemplo, removida ou trocada por faixa
 * noutra aba. ★ Recusar é o certo: gravar `semMeta` numa data que não existe criaria um
 * bloqueio fantasma.
 */
export function comFeriado(atual, semMeta) {
  if (!ehDiaInteiro(atual)) {
    throw Object.assign(new Error('esta data não é mais um bloqueio de dia inteiro'), {
      paraTela: 'Este bloqueio mudou (noutra aba, talvez). A lista foi atualizada — confira e tente de novo.',
    });
  }
  const { semMeta: _antigo, ...resto } = atual;
  return semMeta === true ? { ...resto, semMeta: true } : resto;
}

/**
 * ★★★ O QUE "SALVAR GRADE" GRAVA: os dias da semana e as recorrências. ⚠⚠ NUNCA `excecoes`.
 *
 * ⚠ Antes ela gravava o objeto `agendaAvaliacao` INTEIRO a partir da tela — e, com a gravação
 * na hora, uma tela com a cópia velha apagaria o feriado recém-gravado (o cuidado do revisor).
 */
export const gradeParaSalvar = ({ dias, recorrencias }) => ({ dias, recorrencias });
